import type { UserRole } from '../types'

export const ROLES = {
  INVENTOR: 'inventor' as UserRole,
  COLLABORATOR: 'collaborator' as UserRole,
  ADMIN: 'innovateflow-admin' as UserRole,
}

export const ROLE_HIERARCHY: Record<UserRole, number> = {
  'innovateflow-admin': 3,
  'inventor': 2,
  'collaborator': 1,
}
